import { Reducer } from "redux";

import { GeneratedVideoUrlResponse } from "../models/api/Training";
import { ReferralManagementDispatchTypes } from "../models/dispatchTypes/Referral";
import { ReferralManagementActionDispatchTypes } from "../constants/Referral";

const initialState: GeneratedVideoUrlResponse = {
  loading: false,
  response: {
    url: "",
  },
  error: null,
};

const ReferralManagementReducer: Reducer<
  GeneratedVideoUrlResponse,
  ReferralManagementDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ReferralManagementActionDispatchTypes.GET_REFERRAL_MANAGEMENT_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ReferralManagementActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ReferralManagementActionDispatchTypes.GET_REFERRAL_MANAGEMENT_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
  }
  return state;
};

export default ReferralManagementReducer;
